if (!customElements.get("product-custom-pack-bundle-form")) {
  customElements.define(
    "product-custom-pack-bundle-form",
    class ProductCustomPackkBundleForm extends HTMLElement {
      constructor() {
        super();
        this.productid = this.dataset.id;
        this.selectedVariantId = 0;
        this.enabledofferet = this.dataset.enabledofferet;
        this.enabledofferetProducts = this.dataset.offeretproducts;
        this.enabledSimilarProducts = this.dataset.enablesimilarproduct;
        this.similarproductsids = this.dataset.similarproductsids;
        this.similarSelectedItems = [];
        
        this.form = this.querySelector("form");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.optionSelectors = this.querySelectorAll(
          `.custom-swatch[data-last="false"] .mark_me-custom-bundle`
        );
        this.bunldeItems = this.querySelectorAll(".bundle-product-setp-wrapper .taie-bunlde-item-main");
        this.submitButton = this.form.querySelector(`[type="submit"]`);
        this.singleOptionSelectors = this.querySelectorAll(".custom-variant-trigger-bundle-single");
          
        this.initEventListeners();
      }
      initEventListeners(){
         this.optionSelectors.forEach((el) => {
          el.addEventListener("change", this.onOptionChange.bind(this));
        });
        this.singleOptionSelectors.forEach((el) => {
          el.addEventListener("change", this.onVariantSelect.bind(this));
        });
         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
     
     connectedCallback() {
         this.bunldeItems.forEach( (el) => {
          const firstOption = el.querySelector(`.custom-swatch[data-last="false"] .first-element-option .mark_me-custom-bundle`);
           if(firstOption){
             firstOption.dispatchEvent(new Event('change'));
           }
         });
     }

      updateCounter(){
        const selectedElement = this.querySelector(".custom-variant-placement-wrapper .checked-item");
        console.log(selectedElement,"selectedElement");
        if(selectedElement){
          this.selectedVariantId = selectedElement.dataset.vid;
          if(selectedElement.classList.contains("soldout")){
            this.selectedVariantId = 0;
            this.submitButton.querySelector(".add-to-cart-message").textContent = this.submitButton.dataset.soldtext;
          }else{
            this.submitButton.querySelector(".add-to-cart-message").textContent = this.submitButton.dataset.addtext;
          }
        }else{
          this.selectedVariantId = 0
        }
        if(this.selectedVariantId != 0 && this.selectedVariantId != ""){
          this.setupSimilarproducts();
          this.submitButton.removeAttribute("disabled");
        }else{
          this.submitButton.setAttribute("disabled","disabled");
        }
      }

      setupSimilarproducts(){
        if(this.enabledSimilarProducts === 'true'){
          this.similarSelectedItems = [];
          const similarIds = this.similarproductsids.split("___");
          const variantJSON = JSON.parse(this.querySelector(`div[data-id="custom-variantsJson-${this.productid}"]`).textContent);
          const findSelectVariant = variantJSON.filter((variant) => variant.id == this.selectedVariantId);
          console.log(findSelectVariant,"findSelectVariant");
          if(findSelectVariant.length > 0){
            const selectedFirstOption = findSelectVariant[0].option1;
             const selectedSecondOption = findSelectVariant[0].option2;
            console.log(similarIds,"similarIds");
            Array.from(similarIds , (id) => {
              console.log(id,"id");
              const variantJSON2 = JSON.parse(this.querySelector(`div[data-id="custom-variantsJson-${id}"]`).textContent);
              const findSelectVariant2 = variantJSON2.filter((variant) => selectedFirstOption.includes(variant.option1));
              if(findSelectVariant2.length > 0){
                if(findSelectVariant2.length > 1){
                  const exactMatchVariant = findSelectVariant2.filter((v) => v.option1 == selectedFirstOption && v.option2 == selectedSecondOption );
                  if(exactMatchVariant.length > 0){
                    this.similarSelectedItems.push({
                     id:exactMatchVariant[0].id,
                     title:exactMatchVariant[0].name
                   });
                  }else{
                    this.similarSelectedItems.push({
                     id:findSelectVariant2[0].id,
                     title:findSelectVariant2[0].name
                   });
                  }
                  
                }else{
                  this.similarSelectedItems.push({
                   id:findSelectVariant2[0].id,
                   title:findSelectVariant2[0].name
                 });
                }
                 
              }
            });
          }
        }
      }

      onOptionChange(evt) {
        const mainElement = evt.target.closest(".custom-swatches-bundle-new");
        const selectedValue = evt.target.value;
        const selectedTitle = evt.target.dataset.value;
        const currentWrapper = evt.target.closest(".custom-swatch");
         evt.target.closest(".taie-bunlde-item-main").classList.remove("selectedbox");
        currentWrapper
          .querySelectorAll(".custom-swatch-element")
          .forEach((el) => {
            el.classList.remove("checked-item");
          });
        evt.target.parentElement.classList.add("checked-item");
        mainElement.querySelector(
          ".custom-variant-placement-wrapper"
        ).innerHTML = "";
        const selectedOptions = this.makeOptionSlug(selectedValue, mainElement);
        console.log(selectedOptions,mainElement);
        if (selectedOptions.length > 0) {
          for (let i in selectedOptions) {
            const variantHtml = mainElement
              .querySelector(
                `.varaint-template-data div[data-option="${selectedOptions[i]}"]`
              )
              .cloneNode(true);
            if (variantHtml) {
              mainElement
                .querySelector(".custom-variant-placement-wrapper")
                .appendChild(variantHtml);
            }
          }
          mainElement.querySelector(".custom-variant-placement-wrapper").setAttribute("data-size",mainElement.querySelectorAll(".custom-variant-placement-wrapper .custom-swatch-element").length);
          this.initVariantEvents(mainElement);
        }
        this.updateCounter();
      }
      
      initVariantEvents(mainElement){
         mainElement.querySelectorAll(
          ".custom-variant-placement-wrapper .custom-variant-trigger-bundle"
        ).forEach( (el) =>{
          el.addEventListener("change", this.onVariantSelect.bind(this));
        });
      }
      onVariantSelect(evt){
          const currentWrapper = evt.target.closest(".custom-variant-placement-wrapper");
          currentWrapper
            .querySelectorAll(".custom-swatch-element")
            .forEach((el) => {
              el.classList.remove("checked-item");
            });
          evt.target.parentElement.classList.add("checked-item");
         this.updateCounter();
      }
      
      makeOptionSlug(selectedValue, mainElement) {
        let selectedOptions = [];
        mainElement
          .querySelectorAll(
            `.custom-swatch[data-last="true"] .mark_me-custom-bundle`
          )
          .forEach((el) => {
            selectedOptions.push(`${selectedValue}-${el.value}`);
          });
        return selectedOptions;
      }

      
     
      onSubmitHandler(evt){
        evt.preventDefault();
        const bundleId = new Date().getTime();      
        let items = [];
        let allproperties = [];
        let bundlerItem = 0;
        if(this.enabledSimilarProducts === 'true'){
          for(let i in this.similarSelectedItems){
            if(this.similarSelectedItems[i]){
              allproperties.push(this.similarSelectedItems[i].title);
              items.push({
                "id":this.similarSelectedItems[i].id,
                "quantity":1,
                "properties":{
                  "_customBundleId":bundleId,
                  "_isMainProduct":0,
                  "_baseQty":1,
                }
              });
            }
          }
        }
        if( this.enabledofferet === 'true'){
          if(this.enabledofferetProducts){
            const enabledofferetProductsdata = this.enabledofferetProducts.split("___");
            if(enabledofferetProductsdata.length > 0){
              for(let i in enabledofferetProductsdata){
                if(enabledofferetProductsdata[i]){
                  const slitthestring = enabledofferetProductsdata[i].split("||");
                  let productTitle = slitthestring[1];
                  if(slitthestring[2]){
                    if(slitthestring[2].indexOf("Default") > -1){
                    }else{
                      productTitle = `${productTitle}:${slitthestring[2]}`
                    }
                  }
                  allproperties.push(productTitle);
                  items.push({
                    "id":slitthestring[0],
                    "quantity":1,
                    "properties":{
                      "_customBundleId":bundleId,
                      "_isMainProduct":0,
                      "_baseQty":1,
                      "_isOffertAddon":1
                    }
                  });
                }
              }
            }
          }
        }
        items.push(
          {
            "id":this.selectedVariantId,
            "quantity":1,
            "properties":{
              "_customBundleId":bundleId,
              "_isMainProduct":1,
              "Contenu":allproperties.join("|")
            }
          }
        );
        let formData = {
         'items':items
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
             $("body").trigger("added.ajaxProduct");
            if(this.closest(".custom-modal__centered.active")){
               this.closest(".custom-modal__centered.active").classList.remove("active");
            }
           
          });
      }
     
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
